import styled, { css } from "styled-components";
import ReactInputMask from "react-input-mask";
import { Pagination as PaginationAnt } from "antd";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .filters-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  /* Novo Estilo de Listagem */
  .coupons-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 0 5px; /* Add padding to prevent hover transform from cutting off */
  }

  .coupon-card {
    background: #fff;
    padding: 15px 20px;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    display: flex;
    grid-template-columns: 1.2fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 80px;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
    width: 100%;
    min-width: 800px;

    &:hover {
      border-color: #008037;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      transform: translateX(3px);
    }

    @media (max-width: 1200px) {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 15px;
      padding: 20px;
    }

    .main-info {
      display: flex;
      width: 150px;
      flex-direction: column;
      strong {
        font-size: 14px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-size: 11px;
        color: #008037;
        font-weight: bold;
      }
    }

    .info-item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      color: #666;
      label {
        font-size: 10px;
        text-transform: uppercase;
        color: #bbb;
        margin-bottom: 2px;
      }
      span {
        font-weight: 500;
      }
    }

    .actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      button {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 !important;

        svg {
          margin: 0 !important;
        }
      }
    }
  }

  .status-badge {
    padding: 4px 12px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;

    &.active {
      background: #f6ffed;
      color: #52c41a;
      border: 1px solid #b7eb8f;
    }
    &.inactive {
      background: #fff1f0;
      color: #f5222d;
      border: 1px solid #ffa39e;
    }
    &.single-use {
      background: #e6f7ff;
      color: #1890ff;
      border: 1px solid #91d5ff;
    }
  }
`;

export const Card = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;

export const Form = styled.div`
  margin-top: 70px;
  display: flex;

  input {
    flex: 1;
    background: none;
    border: none;
    border-bottom: 1px solid #484848;
    padding: 10px;
    font-size: 16px;
    color: #ffffff;

    &::placeholder {
      color: #ffffff;
    }
  }

  button {
    margin-left: 25px;
    border: none;
    padding: 10px 45px;
    border-radius: 5px;
    position: relative;
    text-transform: none;
    transition: all 0.15s ease;
    letter-spacing: 0.025em;
    font-size: 0.875rem;
    color: #001b22;
    background-color: #20d071;
    transition: all 0.15s ease;
    &:hover {
      background-color: #20d071cc;
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  border: none;
  border-collapse: separate;
  color: #001b22;
  border-spacing: 0 1em;

  thead {
    tr {
      td {
        padding: 0 15px;
        text-align: center;

        &:last-child {
          text-align: center;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        color: #001b22;
        font-size: 14px;
        height: 40px;
        padding: 0 15px;
        background: #f0f0f0;
        text-align: center;
        a {
          margin: 10px;
        }

        &:first-child {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &:last-child {
          text-align: center;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }
    }
  }
`;

export const Pagination = styled(PaginationAnt)`
  display: flex;
  justify-content: center;
  margin-top: 40px !important;
`;

export const Filters = styled.div`
  margin: 40px 0;
  span {
    color: #001b22;
  }
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 5px;
  justify-content: space-between;
  text-align: center;

  p {
    width: 100%;
    font-size: 12px;
    text-align: left;
    margin: 0 0 2px 5px;
  }
`;

export const InputTel = styled(ReactInputMask)`
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 2px;
  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
  &:hover {
    border-color: #001b22;
  }
  input:focus {
    border-color: #001b22;
  }
`;
